import { render, staticRenderFns } from "./SfIcon.vue?vue&type=template&id=4502e76e"
import script from "./SfIcon.vue?vue&type=script&lang=js"
export * from "./SfIcon.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfIcon.vue?vue&type=style&index=0&id=4502e76e&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "1ec7f3f2"
  
)

export default component.exports